export default "__VITE_ASSET__C_95Fnzc__"